import React, { createContext, useContext, useState, useMemo, useCallback } from 'react'

const SroiFiltersContext = createContext()

export const useSroiFilters = () => {
  const context = useContext(SroiFiltersContext)
  if (!context) {
    throw new Error('useSroiFilters must be used within SroiFiltersProvider')
  }
  return context
}

export const SroiFiltersProvider = ({ children }) => {
  const [selectedRegion, setSelectedRegion] = useState(null)
  const [selectedStakeholder, setSelectedStakeholder] = useState(null)

  // Mutually exclusive filter handlers - when one is selected, others reset to null
  const setRegionExclusive = useCallback(value => {
    setSelectedRegion(value)
    if (value !== null) {
      setSelectedStakeholder(null)
    }
  }, [])

  const setStakeholderExclusive = useCallback(value => {
    setSelectedStakeholder(value)
    if (value !== null) {
      setSelectedRegion(null)
    }
  }, [])

  const value = useMemo(
    () => ({
      selectedRegion,
      setSelectedRegion: setRegionExclusive,
      selectedStakeholder,
      setSelectedStakeholder: setStakeholderExclusive
    }),
    [selectedRegion, selectedStakeholder, setRegionExclusive, setStakeholderExclusive]
  )

  return <SroiFiltersContext.Provider value={value}>{children}</SroiFiltersContext.Provider>
}
